/* Meama: lightweight visitor context + campaign persistence (no cookies). */
(function () {
  'use strict';

  var STORAGE_CAMPAIGN = 'meama_campaign_context_v1';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000;

  function now() {
    return Date.now ? Date.now() : new Date().getTime();
  }

  function safeParse(raw) {
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function safeGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function isExpired(ts) {
    if (!ts) return true;
    return now() - ts > TTL_MS;
  }

  function getUtmFromUrl() {
    var out = {};
    try {
      var params = new URLSearchParams(window.location.search || '');
      var keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var value = params.get(key);
        if (value) out[key] = value;
      }
    } catch (e) {
      return {};
    }
    return out;
  }

  function getExternalReferrer() {
    try {
      var ref = document.referrer || '';
      if (!ref) return '';
      var refUrl = new URL(ref);
      if (refUrl.host === window.location.host) return '';
      return ref;
    } catch (e) {
      return '';
    }
  }

  function normalizeContext(context) {
    if (!context || typeof context !== 'object') return null;

    if (context.firstTouch && isExpired(context.firstTouch.ts)) context.firstTouch = null;
    if (context.lastTouch && isExpired(context.lastTouch.ts)) context.lastTouch = null;

    return context;
  }

  function readContext() {
    return normalizeContext(safeParse(safeGet(STORAGE_CAMPAIGN)) || {});
  }

  function writeContext(context) {
    safeSet(STORAGE_CAMPAIGN, JSON.stringify(context));
  }

  function updateCampaignContext() {
    var utm = getUtmFromUrl();
    var hasUtm = Object.keys(utm).length > 0;
    var referrer = getExternalReferrer();

    var context = readContext() || {};
    var ts = now();
    var landingPath = '';
    try {
      landingPath = window.location.pathname + (window.location.search || '');
    } catch (e) {
      landingPath = '';
    }

    if (!context.firstTouch || !context.firstTouch.ts || isExpired(context.firstTouch.ts)) {
      if (hasUtm || referrer) {
        context.firstTouch = {
          ts: ts,
          landingPath: landingPath,
          referrer: referrer || '',
          utm: hasUtm ? utm : {}
        };
      }
    }

    if (hasUtm || referrer) {
      context.lastTouch = {
        ts: ts,
        landingPath: landingPath,
        referrer: referrer || '',
        utm: hasUtm ? utm : {}
      };
    }

    context.updatedAt = ts;
    writeContext(context);

    window.MeamaPersonalization = window.MeamaPersonalization || {};
    window.MeamaPersonalization.campaignContext = context;
  }

  updateCampaignContext();
})();

